import React, { useEffect, useState } from "react";
import {
  ActivityIndicator,
  Image,
  Linking,
  ScrollView,
  Text,
  TouchableOpacity,
  View,
  TextInput,
} from "react-native";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { useIntl } from "react-intl";
import certificateService from "../../services/certificateService";
import formatDate from "../../utils/formatDate";
import getYear from "../../utils/formatYear";
import styles from "./styles";
import { FormattedMessage } from "react-intl";
import { If, Then, Else } from "react-if";

const ITEMS_PER_PAGE = 5;

const CardsMyCertificatesWallet = () => {
  const [fullListCertificates, setFullListCertificates] = useState([]);
  const [displayedCertificates, setDisplayedCertificates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [filterText, setFilterText] = useState("");
  const [filterDate, setFilterDate] = useState("");
  const intl = useIntl();

  useEffect(() => {
    getCertificatesWallet();
  }, []);

  useEffect(() => {
    let filteredList = fullListCertificates;

    if (filterText) {
      filteredList = filteredList.filter((item) =>
        item.token_name?.toLowerCase().includes(filterText.toLowerCase())
      );
    }

    if (filterDate) {
      filteredList = filteredList.filter((item) =>
        formatDate(item.created_at).startsWith(filterDate)
      );
    }

    const newTotalPages = Math.ceil(filteredList.length / ITEMS_PER_PAGE);
    setTotalPages(newTotalPages);

    const validatedCurrentPage = Math.min(currentPage, newTotalPages) || 1;
    if (currentPage !== validatedCurrentPage) {
      setCurrentPage(validatedCurrentPage);
    }

    const startIndex = (validatedCurrentPage - 1) * ITEMS_PER_PAGE;
    const endIndex = startIndex + ITEMS_PER_PAGE;
    setDisplayedCertificates(filteredList.slice(startIndex, endIndex));
  }, [fullListCertificates, currentPage, filterText, filterDate]);

  const handleOpenCertificate = (uuid, type, language = "pt_BR") => {
    let baseUrl = "";
    const currentUrl =
      typeof window !== "undefined" ? window.location.href : "";

    if (currentUrl.includes("localhost")) {
      baseUrl = "http://localhost:8080";
    } else if (currentUrl.includes("homol.gpxecofi.com.br")) {
      baseUrl = "https://api.homol.gpxecofi.com.br";
    } else {
      baseUrl = "https://api.gpxecofi.com.br";
    }

    let finalUrl = "";
    if (type === "possession") {
      finalUrl = `${baseUrl}/statements/show/${uuid}/${language}`;
    } else {
      finalUrl = `${baseUrl}/certificates/view/${uuid}/${language}`;
    }

    Linking.openURL(finalUrl);
  };

  const getCertificatesWallet = async () => {
    setLoading(true);
    try {
      const authToken = await AsyncStorage.getItem("JWT_TOKEN");
      const response = await certificateService.get(authToken);

      if (response.data && response.data.length > 0) {
        setFullListCertificates(response.data);
      }
    } catch (error) {
      console.error("Erro ao buscar certificados:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDateChange = (text) => {
    const cleaned = text.replace(/\D/g, "");
    const truncated = cleaned.slice(0, 8);
    let formatted = truncated;

    if (truncated.length > 2) {
      formatted = `${truncated.slice(0, 2)}/${truncated.slice(2)}`;
    }
    if (truncated.length > 4) {
      formatted = `${formatted.slice(0, 5)}/${formatted.slice(5)}`;
    }
    setFilterDate(formatted);
  };

  return (
    <>
      <View style={styles.filterContainer}>
        <View style={styles.inputWrapper}>
          <TextInput
            style={styles.input}
            placeholder={intl.formatMessage({
              id: "myCertificates.filter.byName",
            })}
            value={filterText}
            onChangeText={setFilterText}
          />
        </View>
        <View style={styles.inputWrapper}>
          <TextInput
            style={styles.input}
            placeholder={intl.formatMessage({
              id: "myCertificates.filter.byDate",
            })}
            value={filterDate}
            onChangeText={handleDateChange}
            keyboardType="numeric"
            maxLength={10}
          />
        </View>
      </View>

      <If condition={loading}>
        <Then>
          <View style={styles.center}>
            <ActivityIndicator size="large" color="#2797A2" />
          </View>
        </Then>
        <Else>
          <ScrollView nestedScrollEnabled={true}>
            <If condition={displayedCertificates.length > 0}>
              <Then>
                {displayedCertificates.map((item) => (
                  <View style={styles.contentItem} key={item.uuid}>
                    {/* Coluna da Imagem */}
                    <If condition={item.token_image_path}>
                      <Then>
                        <Image
                          source={{
                            uri:
                              "https://filesgpx.s3.us-east-2.amazonaws.com/" +
                              item.token_image_path,
                          }}
                          style={styles.img}
                        />
                      </Then>
                      <Else>
                        <Image
                          source={require("../../../assets/gpxcarbo.png")}
                          style={styles.img}
                        />
                      </Else>
                    </If>

                    {/* Coluna do Nome/Tipo */}
                    <View style={styles.columnContainer}>
                      <Text style={styles.certificateHeaders}>
                        {item.type === "possession" ? (
                          <FormattedMessage id="cardsMyCertificatesWallet.certificadoPosse" />
                        ) : (
                          <FormattedMessage id="cardsMyCertificatesWallet.certificadoCompensacao" />
                        )}
                      </Text>
                      <View style={styles.ativoImgRowContainer}>
                        <View style={styles.nomeAtivoContainer}>
                          <Text style={styles.dadosAtivo}>
                            {item.token_name ?? "Certificado"}
                          </Text>
                        </View>
                      </View>
                    </View>

                    {/* Coluna do Ano */}
                    <View style={styles.columnContainer}>
                      <Text style={styles.certificateHeaders}>
                        <FormattedMessage id="cardsMyCertificatesWallet.certHeadAno" />
                      </Text>
                      <View style={{ height: 24 }}>
                        <Text style={styles.dadosAtivo}>
                          {getYear(item.created_at)}
                        </Text>
                      </View>
                    </View>

                    {/* Coluna da Data */}
                    <View style={styles.columnContainer}>
                      <Text style={styles.certificateHeaders}>
                        <FormattedMessage id="cardsMyCertificatesWallet.certHeadData" />
                      </Text>
                      <View style={{ height: 24 }}>
                        <Text style={styles.dadosAtivo}>
                          {formatDate(item.created_at)}
                        </Text>
                      </View>
                    </View>

                    {/* Botões de Tradução */}
                    <View style={styles.bandeirasBtnContainer}>
                      <TouchableOpacity
                        onPress={() =>
                          handleOpenCertificate(item.uuid, item.type, "pt_BR")
                        }
                      >
                        <Image
                          source={require("../../../assets/flags/bandeira-br.png")}
                          style={styles.flagIcon}
                        />
                      </TouchableOpacity>
                      <TouchableOpacity
                        onPress={() =>
                          handleOpenCertificate(item.uuid, item.type, "en")
                        }
                      >
                        <Image
                          source={require("../../../assets/flags/bandeira-us.png")}
                          style={styles.flagIcon}
                        />
                      </TouchableOpacity>
                      <TouchableOpacity
                        onPress={() =>
                          handleOpenCertificate(item.uuid, item.type, "it")
                        }
                      >
                        <Image
                          source={require("../../../assets/flags/bandeira-it.png")}
                          style={styles.flagIcon}
                        />
                      </TouchableOpacity>
                    </View>
                  </View>
                ))}
              </Then>
              <Else>
                <Text style={styles.dadosAtivo}>
                  <FormattedMessage id="cardsmycertificateswallet.semCertificado" />
                </Text>
              </Else>
            </If>
          </ScrollView>

          <If condition={displayedCertificates.length > 0}>
            <View style={styles.paginationContainer}>
              <TouchableOpacity
                onPress={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
                style={[
                  styles.paginationButton,
                  currentPage === 1 && styles.disabledButton,
                ]}
              >
                <Text style={styles.paginationText}>
                  <FormattedMessage id="myCertificates.pagination.previous" />
                </Text>
              </TouchableOpacity>
              <Text style={styles.paginationInfo}>
                <FormattedMessage
                  id="myCertificates.pagination.pageInfo"
                  values={{
                    currentPage: currentPage,
                    totalPages: totalPages,
                  }}
                />
              </Text>
              <TouchableOpacity
                onPress={() =>
                  setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                }
                disabled={currentPage === totalPages}
                style={[
                  styles.paginationButton,
                  currentPage === totalPages && styles.disabledButton,
                ]}
              >
                <Text style={styles.paginationText}>
                  <FormattedMessage id="myCertificates.pagination.next" />
                </Text>
              </TouchableOpacity>
            </View>
          </If>
        </Else>
      </If>
    </>
  );
};

export default CardsMyCertificatesWallet;
